import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface CheckClock {
    active: number;
    checkClockLoadId: string;
    createdAt: any;
    employeeId: string;
    folio: number;
    registrationDatetime: any;
    registrationDate: any;
    registrationTime: any;
    type: number;
    updatedAt: any;
}

interface CheckClockId extends CheckClock {
    id: string;
}

@Injectable()
export class CheckClockService {

    checkClockCollection: AngularFirestoreCollection<CheckClock>;
    checkClocks: any;

    checkClockDocument: AngularFirestoreDocument<CheckClockId>;
    checkClock: Observable<CheckClockId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.CHECK_CLOCK_COLLECTION;
    }

    postCheckClock(checkClockObject: any) {
        this.checkClockCollection = this.afs.collection(this.collection);

        return this.checkClockCollection.add(checkClockObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getCheckClocks() {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.orderBy('registrationDate', 'desc'));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const folio = data.folio;
                const registrationDate = data.registrationDate;
                const type = data.type;
                const checkClockLoadId = data.checkClockLoadId;

                return { id$, folio, registrationDate, type, checkClockLoadId };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClockSearch(iFolio: any, iRegistratioDate: any) {
        this.checkClockCollection = this.afs.collection(this.collection,
        ref => ref.where('folio', '==', iFolio).where('registrationDate', '==', iRegistratioDate));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                return { id$ };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClock(id$: string) {
        this.checkClockDocument = this.afs.doc(this.collection + '/' + id$);

        this.checkClock = this.checkClockDocument.valueChanges();

        return this.checkClock.map(object => object);
    }

    putCheckClock(checkClockObject: any, id$: string) {
        this.checkClockCollection = this.afs.collection(this.collection);

        return this.checkClockCollection.doc(id$).update(checkClockObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delCheckClock(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.checkClockDocument = this.afs.doc(this.collection + '/' + id$);

        return this.checkClockDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

    postCheckClockAtomic(checkClocks) {
        const batch = firebase.firestore().batch();

        for (let item in checkClocks) {
            const id = checkClocks[item].folio + '_' + checkClocks[item].registrationDatetime.toISOString();

            const checkClockRef = firebase.firestore().collection(this.collection).doc(id);
            batch.set(checkClockRef, checkClocks[item]);
        }

        return batch.commit();
    }

    getCheckClocksUnregisteredEmployees(checkClockLoadId$: string) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('employeeId', '==', '').
            where('checkClockLoadId', '==', checkClockLoadId$));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const folio = data.folio;
                const registrationDatetime = data.registrationDatetime;
                const type = data.type;
                const checkClockLoadId = data.checkClockLoadId;
                const employeeId = data.employeeId;

                return { id$, folio, registrationDatetime, type, checkClockLoadId, employeeId };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClocksRegisteredEmployees(checkClockLoadId$: string) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('employeeId', '>', '').
            where('checkClockLoadId', '==', checkClockLoadId$));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const folio = data.folio;
                const registrationDatetime = data.registrationDatetime;
                const type = data.type;
                const checkClockLoadId = data.checkClockLoadId;
                const employeeId = data.employeeId;

                return { id$, folio, registrationDatetime, type, checkClockLoadId, employeeId };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClocksByFolio(folioVal: number) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('employeeId', '==', '').
            where('folio', '==', folioVal));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const folio = data.folio;
                const checkClockLoadId = data.checkClockLoadId;
                const employeeId = data.employeeId;

                return { id$, folio, checkClockLoadId, employeeId };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    putCheckClockAtomic(checkClocks) {
        const batch = firebase.firestore().batch();

        for (let item in checkClocks) {
            const id = checkClocks[item].id;

            const checkClockRef = firebase.firestore().collection(this.collection).doc(id);
            batch.update(checkClockRef, { employeeId: checkClocks[item].employeeId, updatedAt: checkClocks[item].updatedAt });
        }

        return batch.commit();
    }

    getCheckClocksByRegistrationDate(iRegistrationDate: any) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('registrationDate', '==', iRegistrationDate));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const folio = data.folio;
                const registrationDatetime = data.registrationDatetime;
                const registrationDate = data.registrationDate;
                const registrationTime = data.registrationTime;
                const type = data.type;
                const employeeId = data.employeeId;

                return { id$, folio, registrationDatetime, type, employeeId, registrationDate, registrationTime };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClocksEmployeesByRegistrationDate(iRegistrationDate: any) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('registrationDate', '==', iRegistrationDate)
                                    .where('employeeId', '>', ''));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClock;

                const registrationDate = data.registrationDate;
                const employeeId = data.employeeId;

                return { id$, employeeId, registrationDate };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    getCheckClocksByLoadId(checkClockLoadId: string) {
        this.checkClockCollection = this.afs.collection(this.collection, ref => ref.where('checkClockLoadId', '==', checkClockLoadId));

        this.checkClocks = this.checkClockCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                return { id$ };
            });
        }).map(object => object);

        return this.checkClocks;
    }

    deleteCheckClockAtomic(checkClocks) {
        const batch = firebase.firestore().batch();

        for (let item in checkClocks) {
            const id = checkClocks[item].id;
            console.log(id);

            const checkClockRef = firebase.firestore().collection(this.collection).doc(id);

            batch.delete(checkClockRef);
        }

        return batch.commit();
    }

}
